import {isDevMode} from '@angular/core';
import {Action, ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
// import * as fromAuthUsers from './entities/uaa/auth-user.reducer';
import * as fromRegions from './entities/system-configurations/administrative-area/region/region.reducer';
import * as fromDistricts from './entities/system-configurations/administrative-area/district/district.reducer';
import * as fromWards from './entities/system-configurations/administrative-area/ward/ward.reducer';
import * as fromLoadingState from './entities/shared/loading-state/loading-state.reducer'
import * as fromStoreItem from './entities/store-item/store-item.reducer';


export interface AppState {
  // [fromAuthUsers.authUsersFeatureKey]: fromAuthUsers.State,
  [fromLoadingState.loadingStatesFeatureKey]: fromLoadingState.State,
  [fromRegions.regionsFeatureKey]: fromRegions.State,
  [fromDistricts.districtsFeatureKey]: fromDistricts.State,
  [fromWards.wardsFeatureKey]: fromWards.State,
  [fromStoreItem.storeItemsFeatureKey]: fromStoreItem.State
}

export const reducers: ActionReducerMap<AppState> = {
  // [fromAuthUsers.authUsersFeatureKey]: fromAuthUsers.reducer,
  [fromLoadingState.loadingStatesFeatureKey]: fromLoadingState.reducer,
  [fromRegions.regionsFeatureKey]: fromRegions.reducer,
  [fromDistricts.districtsFeatureKey]: fromDistricts.reducer,
  [fromWards.wardsFeatureKey]: fromWards.reducer,
  [fromStoreItem.storeItemsFeatureKey]: fromStoreItem.reducer,
};

export function clearState(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state: AppState, action: Action): AppState => {
    if (action.type === '[AuthUser/API] Logout') {
      state = undefined;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = isDevMode() ? [clearState] : [];

export const appState = (state: AppState) => state;

